import { render } from "./HospMap.vue?vue&type=template&id=df8b12d4"
import script from "./HospMap.vue?vue&type=script&lang=js"
export * from "./HospMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__